import React from 'react';
import useBinaryUrl from '../../utils/useBinaryUrl';

// <img> de arquivo protegido: baixa pela rota binary com o token. Enquanto carrega, quando o
// registro não tem arquivo ou quando dá erro, mostra `children` (ex.: iniciais) ou `fallbackSrc`.
const BinaryImage = ({ resource, id, field, fallbackSrc, children, alt = '', ...imgProps }) => {
  const { url } = useBinaryUrl({ resource, id, field });

  if (url) return <img src={url} alt={alt} {...imgProps} />;
  if (children) return children;
  if (fallbackSrc) return <img src={fallbackSrc} alt={alt} {...imgProps} />;
  return null;
};

export default BinaryImage;
